import SuppliersList from "@/components/inventory/suppliers/SuppliersList";
import { useAppSelector } from "@/redux/features/hooks";

const SuppliersPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  if (!restaurant) return null;

  return <SuppliersList restaurantId={restaurant.id} />;
};

export default SuppliersPage;
